import { Localization } from './language';
import { merchantInfoByProductUUID } from './productUUIDConstants';

export enum CardNetwork {
  Visa = 'Visa',
  Mastercard = 'Mastercard',
  Amex = 'Amex',
}
const cardNetworkLicensorMap: Record<CardNetwork, string> = {
  [CardNetwork.Visa]: 'Visa USA Inc',
  [CardNetwork.Mastercard]: 'Mastercard International Incorporated',
  [CardNetwork.Amex]: 'American Express',
};

export enum IssuingBank {
  FEB = 'First Electronic Bank',
}

export const getIssuerDisclosure = (
  productUUID: string,
  cardName: string,
  language: Localization
): string => {
  const { cardNetwork, issuingBank } = merchantInfoByProductUUID[productUUID];
  const networkName = cardNetworkLicensorMap[cardNetwork];

  let issuerDisclosure = language.issuerDisclosurePlaceholder
    .replaceAll('{cardName}', cardName)
    .replaceAll('{bankName}', issuingBank)
    .replaceAll('{networkName}', networkName);

  if (cardNetwork === CardNetwork.Mastercard) {
    issuerDisclosure += language.mastercardTrademarks;
  }

  return issuerDisclosure;
};

export const getIssuerDisclosureInStore = (
  productUUID: string,
  cardName: string,
  language: Localization
): string => {
  const { cardNetwork, issuingBank } = merchantInfoByProductUUID[productUUID];
  const networkName = cardNetworkLicensorMap[cardNetwork];

  let issuerDisclosure = language.issuerDisclosurePlaceholderStorePage
    .replaceAll('{cardName}', cardName)
    .replaceAll('{bankName}', issuingBank)
    .replaceAll('{networkName}', networkName);

  if (cardNetwork === CardNetwork.Mastercard) {
    issuerDisclosure += language.mastercardTrademarks;
  }

  return issuerDisclosure;
};
